import type {
  ReferenceDetailRaw,
  ReferenceDetailUI,
  ReferenceListFilters,
  ReferenceRaw,
  ReferenceRow,
} from "~/features/references/types";
import { seqId } from "./reference";

function toReferenceRow(raw: ReferenceRaw): ReferenceRow {
  return {
    id: raw.id,
    seqId: seqId(raw.seq),
    title: raw.title,
    shortCode: raw.shortCode,
    isbn: raw.isbn ?? "",
    documentUrl: raw.documentUrl ?? null,
    isDeactivated: Boolean(raw.deactivatedAt),
  };
}

/** Map the raw reference list to UI rows, applying the client-side exclude-deactivated filter (V1 parity). */
export function toReferenceRowList(raws: readonly ReferenceRaw[], filters: ReferenceListFilters): ReferenceRow[] {
  const rows = raws.map(toReferenceRow);
  return filters.excludeDeactivated ? rows.filter((r) => !r.isDeactivated) : rows;
}

export function toReferenceDetailUI(raw: ReferenceDetailRaw): ReferenceDetailUI {
  const file = raw.referenceFiles[0] ?? null;
  return {
    id: raw.id,
    seqId: seqId(raw.seq),
    title: raw.title,
    shortCode: raw.shortCode,
    isbn: raw.isbn ?? "",
    authors: (raw.authors ?? []) as string[],
    publishers: raw.referencePublishers.map(({ publisherId, publisher }) => publisher?.name ?? publisherId),
    publishedDate: raw.publishedDate ?? null,
    edition: raw.edition ?? null,
    documentUrl: raw.documentUrl ?? null,
    evidencesCount: raw.evidencesAggregate.aggregate?.count ?? 0,
    isDeactivated: Boolean(raw.deactivatedAt),
    file: file
      ? {
          id: file.id,
          googleDriveFileId: file.googleDriveFileId,
          hasImages: file.imagesCreatedAt != null,
          numPages: file.numPages ?? null,
          folioOffset: file.folioOffset ?? 0,
        }
      : null,
  };
}
